/**
 * Ad Provider Configuration
 *
 * Switch between "refinery89" and "adsense" per domain.
 * To switch back to AdSense, change the provider to "adsense".
 *
 * Refinery89 tags are domain-wide (serve all URLs on the domain).
 */

// Provider per domain: "refinery89" | "adsense"
const AD_PROVIDERS = {
  "tipdeal.nl": "refinery89",
  "1001promocodes.com": "refinery89",
  "1001cupomdedescontos.com.br": "refinery89",
  // Next.js also serves these but they stay on AdSense for now:
  "tipdeal.be": "adsense",
};

// Refinery89 script tags per domain
const REFINERY89_TAGS = {
  "tipdeal.nl": "https://tags.refinery89.com/tipdealnl.js",
  "1001promocodes.com": "https://tags.refinery89.com/1001promocodescom.js",
  "1001cupomdedescontos.com.br": "https://tags.refinery89.com/1001cupomdedescontoscombr.js",
};

// AdSense config (kept for easy switch-back)
const ADSENSE_CLIENT = "ca-pub-2665851518065203";
const ADSENSE_SCRIPT = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;

/**
 * Get the ad provider for a domain
 * @param {string} domain
 * @returns {"refinery89" | "adsense"}
 */
export function getAdProvider(domain) {
  return AD_PROVIDERS[domain] || "adsense";
}

/**
 * Get the Refinery89 script URL for a domain
 * @param {string} domain
 * @returns {string|null}
 */
export function getRefinery89Tag(domain) {
  return REFINERY89_TAGS[domain] || null;
}

/**
 * Get the AdSense script URL
 * @returns {string}
 */
export function getAdSenseScript() {
  return ADSENSE_SCRIPT;
}

/**
 * Get the AdSense client ID
 * @returns {string}
 */
export function getAdSenseClient() {
  return ADSENSE_CLIENT;
}